<template>
  <div>
    <a-card size="small" title="简单配置">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        <searchE @handleSearch="handleSubmit"></searchE>
        <tableE ref="cloudconfigTableID"></tableE>

    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            platformcode:''
        };
    },
    methods: {
        handleSubmit(searchP){
            this.platformcode = searchP.platformcode;
            this.$refs.cloudconfigTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "addsimpconfig",
                query: {
                    platformcode:this.platformcode,
                    configcode:''
                }
            });
        },
    },
    components:{
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
